<mat-expansion-panel class="expansion-panel" #ex data-action="expanded-recording-card">
  <mat-expansion-panel-header>
    <mat-panel-title class="expansion-panel-title">
      <div class="header-container">
        <div class="left">
          <mat-icon class="expansion-panel-header-icon">smart_display</mat-icon>
          <div>
            <div class="title-name">{{ conversation().title }}</div>
            <div class="subtitle-time">
              <meeting-analysis-start-and-end [conversation]="conversation()"></meeting-analysis-start-and-end>
            </div>
          </div>
        </div>
        <div class="right" (click)="stopPropagation($event)">
          <a mat-flat-button color="primary"
             [routerLink]="routeService.applyRoutePrefix(conversation().meetingDate | conversationPagePath: conversation().id) | async"
             data-action="clicked-view-recording"
          >{{ 'COMMON.VIEW' | translate }}
          </a>
        </div>
      </div>
    </mat-panel-title>
  </mat-expansion-panel-header>
  <div class="summary-container">
    <div class="title">{{ 'COMMON.SUMMARY' | translate }}</div>
    {{ conversation().summary }}
  </div>

  <div class="details-container">
    <div>
      <div class="detail-title">{{ 'COMMON.DATE' | translate }}</div>
      <div class="value">{{ conversation().meetingDate | date: 'MMMM d, yyyy' }}</div>
    </div>
    <div>
      <div class="detail-title">{{ 'COMMON.MEETING_LINK' | translate }}</div>
      <a [href]="meetingLink()">{{ meetingLink() }}</a>
    </div>
    <div>
      <div class="detail-title">{{ 'COMMON.SOURCE' | translate }}</div>
      <div class="value">{{ conversation().source | meetingAnalysisSource | translate }}</div>
    </div>
    <div>
      <div class="detail-title">{{ 'COMMON.GUESTS' | translate }}</div>
      <div class="value">
        @if (ex.expanded) {
          <meeting-analysis-guests
            [contactIds]="externalAttendeesContactIds()"
            [userIds]="internalAttendees()"
            [useAvatarGroup]="true"
          ></meeting-analysis-guests>
        }
      </div>
    </div>
    <div>
      <div class="detail-title">
        {{ 'COMMON.VISIBILITY' | translate }}
        <mat-icon (click)="openVisibilityInfoDialog()" class="info-icon">info_outline</mat-icon>
      </div>
      <div class="value">
        @if (!updatingPrivacyLevel() && (namespaceName$ | async); as namespaceName) {
          <glxy-form-field>
            <mat-select [ngModel]="conversationPrivacyLevel()" (selectionChange)="changePrivacyLevel($event.value)">
              <mat-option [value]="privacyLevels.PRIVACY_LEVEL_OPEN">
                {{ 'VISIBILITY.OPEN' | translate: { namespaceName: namespaceName } }}
              </mat-option>
              <mat-option [value]="privacyLevels.PRIVACY_LEVEL_UNLISTED">
                {{ 'VISIBILITY.UNLISTED_V2' | translate: { namespaceName: namespaceName } }}
              </mat-option>
              <mat-option [value]="privacyLevels.PRIVACY_LEVEL_PRIVATE">
                {{ 'VISIBILITY.PRIVATE' | translate }}
              </mat-option>
            </mat-select>
          </glxy-form-field>
        } @else {
          <div class="stencil-shimmer stencil-privacy-level"></div>
        }
      </div>
    </div>
  </div>

</mat-expansion-panel>
